import React, { useEffect, useState } from 'react';
import { View } from 'react-native';

import HeaderDefault from '../../components/HeaderDefault';
import AuthCodeInput from '../../components/Form/AuthCodeInput';

import styles from './styles';

const ChangePassword = ({ navigation }) => {
    const [password, setPassword] = useState('');

    useEffect(() => {
        resetPassword();
    },[password])

    function resetPassword(){
        if(password.length === 6){
            navigation.navigate('NewPassword', {password: password});
        }
    }

    return (
        <>
            <HeaderDefault title={'Alterar senha'} />

            <View style={styles.container}>
                <AuthCodeInput
                    cellCount={6}
                    isPassword={true}
                    value={password}
                    onValueChange={(value) => setPassword(value)}
                    label="Digite sua senha atual"
                />
            </View>
        </>
    );
}

export default ChangePassword;